import EditProcedureDataModal from './EditProcedureDataModal';

export default EditProcedureDataModal;
